"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.TOKENS = exports.SIZE_OPTIONS = void 0;
let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["PRIMARY"] = "primary";
  TYPE_OPTIONS["SECONDARY"] = "secondary";
  TYPE_OPTIONS["CRITICAL"] = "critical";
  TYPE_OPTIONS["WHITE"] = "white";
  TYPE_OPTIONS["PRIMARY_SUBTLE"] = "primarySubtle";
  TYPE_OPTIONS["CRITICAL_SUBTLE"] = "criticalSubtle";
  TYPE_OPTIONS["BUNDLE_BASIC"] = "bundleBasic";
  TYPE_OPTIONS["BUNDLE_MEDIUM"] = "bundleMedium";
  TYPE_OPTIONS["BUNDLE_TOP"] = "bundleTop";
  return TYPE_OPTIONS;
}({});
exports.TYPE_OPTIONS = TYPE_OPTIONS;
let SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  SIZE_OPTIONS["LARGE"] = "large";
  return SIZE_OPTIONS;
}({});
exports.SIZE_OPTIONS = SIZE_OPTIONS;
let TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["heightButton"] = "heightButton";
  TOKENS["loadingWidth"] = "loadingWidth";
  TOKENS["loadingHeight"] = "loadingHeight";
  TOKENS["fontSizeButton"] = "fontSizeButton";
  TOKENS["paddingButton"] = "paddingButton";
  TOKENS["paddingButtonWithIcons"] = "paddingButtonWithIcons";
  TOKENS["paddingButtonWithLeftIcon"] = "paddingButtonWithLeftIcon";
  TOKENS["paddingButtonWithRightIcon"] = "paddingButtonWithRightIcon";
  TOKENS["backgroundButton"] = "backgroundButton";
  TOKENS["backgroundButtonHover"] = "backgroundButtonHover";
  TOKENS["backgroundButtonActive"] = "backgroundButtonActive";
  TOKENS["backgroundButtonFocus"] = "backgroundButtonFocus";
  TOKENS["colorTextButton"] = "colorTextButton";
  TOKENS["colorTextButtonHover"] = "colorTextButtonHover";
  TOKENS["colorTextButtonActive"] = "colorTextButtonActive";
  TOKENS["borderColorButtonFocus"] = "borderColorButtonFocus";
  return TOKENS;
}({});
exports.TOKENS = TOKENS;